export interface LinkAccountResponseApiModel {
  redirectUrl: string;
  requiresConsent: boolean;
  accountId: string;
  accountStatus: IntegrationStatus;
  action: ActionType;
  integrationSlug: string;
  integrationType: IntegrationType;
}

export interface SettingsApiResponseModel {
  links: { [key: string]: string };
  features?: Feature[];
}

export type Feature = '';

export interface GetInstructionsApiResponseModel {
  footerText: string;
  headerText: string;
  showInstructions: boolean;
  pleaseNoteText: string;
  steps: IntergrationInstructionStep[];
  termsAndConditions?: IntegrationTermsAndConditions;
  readonly: boolean;
}

export interface IntegrationTermsAndConditions {
  url: string;
  input: IntergrationInstructionInput;
}

export interface IntergrationInstructionStep {
  content: IntergrationInstructionContent[];
  inputs: IntergrationInstructionInput[];
}

export interface IntergrationInstructionOption {
  key: string;
  value: string;
}

export interface StrVal {
  [key: string]: string;
}

export interface IntergrationInstructionOptionGroups {
  name: string;
  options: IntergrationInstructionOption[];
}

export interface IntergrationInstructionInput {
  placeholder: string;
  propertyName: string;
  type: InputType;
  value?: string;
  valueType: InputValueType;
  optionGroups: IntergrationInstructionOptionGroups[];
  validationRules: IntergrationInstructionInputValidation;
}

export interface IntergrationInstructionContent {
  elementType: 'Paragraph' | 'UnOrderedList' | 'ChildItem' | 'Image';
  attributes: StrVal;
  content: string;
  childElements: IntergrationInstructionContent[];
}

export interface IntergrationInstructionInputValidation {
  maxLength: number;
  maxValue: number;
  minLength: number;
  minValue: number;
  pattern: string;
  required: boolean;
  helperText: string;
}

export type InputType = 'Unknown' | 'FreeType' | 'MultipleChoice' | 'TrueOrFalse';

export type InputValueType = 'Unknown' | 'Text' | 'Number' | 'DateTime' | 'Boolean';

export const ActionTypes = <const>['Link', 'Configure', 'Delete', 'Renew', 'Install', '', 'AccountList'];
export type ActionType = (typeof ActionTypes)[number];

export interface Integration {
  slug: string;
  name: string;
  maxAccounts?: number;
  type: IntegrationType;
  accounts: Account[];
  accountActions: ActionType[];
}

export type IntegrationType = 'Marketplace' | 'Courier' | 'Auth';

export interface Account {
  id: string;
  name: string;
  status: IntegrationStatus;
  actions: ActionType[];
}

export type IntegrationStatus =
  | 'Unknown'
  | 'Active'
  | 'Inactive'
  | 'Submitted'
  | 'Rejected'
  | 'Expired'
  | 'ConfigurationRequired'
  | 'ConsentRequired'
  | 'Pending'
  | 'PendingDeletion';
